import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {
  Main,
  Timeline,
  Expertise,
  Education,
  Project,
  Contact,
  Navigation,
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';

function App() {
    const [mode, setMode] = useState<string>('dark');
    const { i18n } = useTranslation();
    const currentLanguage = i18n.resolvedLanguage || i18n.language || 'en';
    const normalizedLanguage = currentLanguage.startsWith('no') ? 'no' : 'en';

    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    useEffect(() => {
        document.documentElement.lang = normalizedLanguage;
        document.title = normalizedLanguage === 'no' ? 'Tina Kjær - CV' : 'Tina Kjær - Resume';
    }, [normalizedLanguage]);

    return (
    <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
        <Navigation parentToChild={{mode}} modeChange={handleModeChange}/>
        <FadeIn transitionDuration={700}>
            <Main/>
            <Expertise/>
            <Education/>
            <Timeline/>
            <Project/>
            <Contact/>
        </FadeIn>
        <Footer />
    </div>
    );
}

export default App;
